import axios from '../config/axios';

export function apiGetEmail() {
    return axios.get('emails');
}

export function apiSaveEmail(data) {
    return axios.put(`emails/${data.id}`, data);
}
